export default __webpack_public_path__ + "static/media/Abilone-Shell-Necklace.c59147f3.jpg";